export default __webpack_public_path__ + "static/media/955.f8891203.png";